import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RomAppState, RomEditorState } from 'routes/rom/interfaces';
import { Rom } from 'shared/interfaces';
import { RomEventTypes, RomUpdateAction } from './types';
import { apiPostRom, apiGetRom, apiPostUpdatedRom } from './api';
import { getRomId, hasMetaDataList, hasMetaDataListItems } from './selectors';

type RomDispatch = ThunkDispatch<RomAppState, any, AnyAction>;
type GetState = () => RomAppState;

export const setRom = (rom: RomEditorState) => ({ type: RomEventTypes.SET_ROM, rom });
export const setRomValue = <K extends keyof RomEditorState>(name: K, value: RomEditorState[K]): RomUpdateAction<K> =>
    ({ type: RomEventTypes.SET_ROM_VALUE, name, value });

export const getRom = (romId?: string) => (dispatch: RomDispatch, getState: GetState) => {
    romId = romId || getRomId(getState());
    if (!romId) {
        throw new Error('No ROM is being edited');
    }
    return apiGetRom(romId).then(
        (results: Rom) => dispatch(setRom(results))
    );
};

export const createRom = (rom: Rom) => (dispatch: RomDispatch) => {
    return apiPostRom(rom).then( 
        (results: Rom) => !!results && dispatch(getRom(results.romId))
    );
};
export const updateRom = (rom: Rom, romId: string) => (dispatch: RomDispatch) => {
    return apiPostUpdatedRom(rom, romId).then(
        (results: Rom) => dispatch(getRom(results.romId))
    );
};

export const clearRom = () => ({ type: RomEventTypes.CLEAR_ROM });

export const createMetaDataList = (key: string) => ({ type: RomEventTypes.CREATE_META_DATA_LIST, key });

export const removeMetaDataList = (key: string) => ({ type: RomEventTypes.REMOVE_META_DATA_LIST, key });

export const addMetaDataItem = (key: string, item: unknown) => ({ type: RomEventTypes.CREATE_META_DATA_ITEM, key, item });

export const updateMetaDataList = (key: string, item: unknown) => async (dispatch: RomDispatch, getState: GetState) => {
    if (!hasMetaDataList(getState(), key)) {
        await dispatch(createMetaDataList(key));
    }
    dispatch(addMetaDataItem(key, item));
};

export const removeMetaDataItem = (key: string, id: unknown) => async (dispatch: RomDispatch, getState: GetState) => {
    await dispatch({ type: RomEventTypes.REMOVE_META_DATA_ITEM, key, id });
    if (!hasMetaDataListItems(getState(), key)) {
        dispatch(removeMetaDataList(key));
    }
};

export const setMetaDataItemValue = (key: string, id: unknown, name: string, value: unknown) =>
    ({ type: RomEventTypes.UPDATE_META_DATA_ITEM_VALUE, key, id, name, value });
